import React from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { PARO_TIPS } from '../../../shared/constants/paroTips'
import FlopsCard from './FlopsCard'
import ProfileStrengthBar from './ProfileStrengthBar'

const ParoTips = ({ step }) => {
  const { text, flops, label, value } = PARO_TIPS.find((tip) => tip.id === step) || {}

  return (
    <>
      <Box>
        <Typography variant="body2" gutterBottom>
          Tips from Paro HQ
        </Typography>
      </Box>
      <Box my={2}>
        <FlopsCard {...flops} />
      </Box>
      <Box>
        <Typography variant="body2" paragraph>
          {text}
        </Typography>
      </Box>

      <ProfileStrengthBar label={label} value={value} />
    </>
  )
}

export default ParoTips
